import { X } from 'lucide-react';
export default function Toast({ msg, type, onClose }) {
  const colors = { success:'#52875A', error:'#C0392B', info:'var(--gold)' };
  const icons  = { success:'✓', error:'✕', info:'ℹ' };
  return (
    <div className={`toast ${type||''}`} style={{borderLeftColor:colors[type]||'var(--gold)'}}>
      <span style={{color:colors[type],fontWeight:600,fontSize:'1rem'}}>{icons[type]}</span>
      <span className="toast-msg">{msg}</span>
      <button onClick={onClose} style={{marginLeft:'auto',background:'none',border:'none',color:'var(--text-dim)',cursor:'pointer',display:'flex'}}><X size={14}/></button>
    </div>
  );
}
